"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATE_TIME_FULL_FORMAT = exports.DATE_FORMAT_OPTIONS = exports.DATE_TIME_FORMAT = exports.TIME_FORMAT = exports.SHORT_FORMAT = exports.ISO_TWO_DIGITS_FORMAT = exports.SINGLE_DATE = exports.MULTI_DATE = exports.END_DATE = exports.START_DATE = void 0;
exports.START_DATE = 'startDate';
exports.END_DATE = 'endDate';
exports.MULTI_DATE = 'multiDate';
exports.SINGLE_DATE = 'singleDate';
exports.ISO_TWO_DIGITS_FORMAT = 'MM/dd/yy';
exports.SHORT_FORMAT = 'MMM d';
exports.TIME_FORMAT = 'hh:mm a';
exports.DATE_TIME_FORMAT = 'MM/dd/yyyy, HH:mm';
exports.DATE_FORMAT_OPTIONS = 'yyyy-MM-dd';
exports.DATE_TIME_FULL_FORMAT = "yyyy-MM-dd'T'HH:mm:ss.SSSxxx";
